import Spinner from '../ui/Spinner/Spinner'

export const GlobalLoader = () => (
  <Spinner variant="fullscreen" text="Loading application..." />
)

export const PageLoader = () => (
  <Spinner variant="page" />
)

export const DashboardLoader = () => (
  <Spinner variant="page" text="Loading Dashboard..." />
)

export const ProjectLoader = () => (
  <Spinner variant="page" text="Loading Project..." />
)

export const InlineLoader = () => (
  <Spinner size="small" variant="inline" />
)
